(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerOutreachListController', [
            'MW.Influencers.IcmDialogService',
            'MW.Framework.TranslationService',
            'MW.Framework.ICMUserService',
            'MW.Framework.ICMEmailService',
            'MW.ContactManager.OutreachListFactory',
            'MW.Framework.CoreUserService',
            'MW.ContactManager.OutreachService',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.ContactManager.OutreachList',
            'MW.ContactManager.TemplateList',
            'MW.Influencers.EmailAnalyticsService',
            'MW.Influencers.AccountEngagementWidget',
            'MW.Configuration',
            'MW.Influencers.OutreachBannerService',
            'MW.Influencers.ActionBarService',
            'MW.Influencers.OutreachTemplate',
            'MW.Influencers.EmailTemplateService',
            'mwAppComponents',
            'MW.Influencers.UserActivityService'
        ])
        .controller('ContactManagerOutreachListController', [
            '$scope',
            'DialogService',
            'translationService',
            'ICMUserService',
            'ICMEmailService',
            '$location',
            '$translate',
            '$mdDialog',
            'OutreachListFactory',
            'CoreUserService',
            'OutreachService',
            '$q',
            'ContactManagerNavigationService',
            'EmailAnalyticsService',
            'OutreachBannerService',
            'ActionBarService',
            'ICM_ASSETS_URL',
            'EmailTemplateService',
            'mwBannerService',
            'UserActivityService',
            ContactManagerOutreachListController
        ]);

    function ContactManagerOutreachListController(
        $scope,
        DialogService,
        translationService,
        ICMUserService,
        ICMEmailService,
        $location,
        $translate,
        $mdDialog,
        OutreachListFactory,
        CoreUserService,
        OutreachService,
        $q,
        ContactManagerNavigationService,
        EmailAnalyticsService,
        OutreachBannerService,
        ActionBarService,
        ICM_ASSETS_URL,
        EmailTemplateService,
        mwBannerService,
        UserActivityService
    ) {
        this.mwBannerService = mwBannerService;
        this.$scope = $scope;
        this.ICM_ASSETS_URL = ICM_ASSETS_URL;
        this.DialogService = DialogService;
        this.translationService = translationService;
        this.ICMUserService = ICMUserService;
        this.ICMEmailService = ICMEmailService;
        this.EmailTemplateService = EmailTemplateService;
        this.OutreachListFactory = new OutreachListFactory();
        this.$location = $location;
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.emptyStateVisible = false;
        this.isPermissions = false;
        this.OutreachService = OutreachService;
        this.$q = $q;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.CoreUserService = CoreUserService;
        this.OutreachBannerService = OutreachBannerService;
        this.ActionBarService = ActionBarService;
        this.selectedItems = [];
        this.outreachEmailQueryPageSize = 25;
        this.totalEmails = 0;
        this.sortFieldMap = {
            subject: 'subject',
            approvedSenderName: 'approvedSender.name',
            scheduledDateStamp: 'scheduledDate',
            status: 'status'
        };
        this.EmailAnalyticsService = EmailAnalyticsService;
        this.CoreUserService.hasPermissions().then(function (isPermissions) {
            this.isPermissions = isPermissions;
            this._enableComposeButton();
        }.bind(this));

        /**
         * Initialize the Array of emails.  This will be populated under getEmails() in this file.
         * @type {Array}
         */
        this.outreachEmails = [];
        this.activeTab='outreaches';
        this.outreachTab = 'outreaches';
        this.templateTab = 'templates';
        this.outreachTabString = this.$translate.instant('icm-outreach__template--outreaches-tab');
        this.templateTabString = this.$translate.instant('icm-outreach__template--templates-tab');
        this.pageNumber = this.$location.search().page ? parseInt(this.$location.search().page) : 0;
        this.sortField = this.$location.search().sortField;
        this.sortOrder = this.$location.search().sortOrder;
        this.filterByStatusType = this.$location.search().filterByStatusType || undefined;
        this.findText = this.$location.search().findText || undefined;
        this.isInitializing = true;
        this.getEmails(this.pageNumber, this.sortOrder, this.sortField, this.filterByStatusType, this.findText).then(function(){
            this.isInitializing = false;
        }.bind(this)); // Initiating call to get all outreach emails list

        this.$scope.$on('$locationChangeStart', function() {
            this.DialogService.removeFlashMessageByClassName('relevantMessage');
        }.bind(this));

        this._getCompanyAggregations();

        this.approveSenderLoading = true;
        this.approvedSenderList = [];
        this.getApprovedSenders().then(function(approvedSendersList) {
            this.approvedSenderList = approvedSendersList;
            if (this.approvedSenderList.length > 0) {
                //Getting unique domains from the approvedSendersList
                var domainNames = _.chain(approvedSendersList)
                    .map(function(sender) {
                        return sender.email.split('@').pop();
                    })
                    .uniq()
                    .value();
                this.OutreachBannerService.checkVerifiedDomains(domainNames,{attachTo:'.banner-space'});
            }
        }.bind(this))
        .catch(function (error) {
            // shouldn't show an error if it unapproved or request is pending
            if (error !== 'unapproved' && error !== 'request_pending') {
                this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }
        }.bind(this));

        // For the action bar
        this.actions = [
            {
                label: this.$translate.instant('icm-outreach__email-list--compose-email-button'),
                doNotDisableActions: true,
                tutorialId: 'icm-outreach__email-list--compose-email-button',
                onClick: ()=>{ this.compose(); },
                enabled: true
            }
        ];

        this.actions = [
            {
                label: this.$translate.instant('icm-outreach__email-list--compose-email-button'),
                doNotDisableActions: true,
                tutorialId: 'icm-outreach__email-list--compose-email-button',
                onClick: ()=>{ this.compose(); },
                enabled: true
            },
            {
                label: this.$translate.instant('icm-outreach__email-list--create-template-button'),
                doNotDisableActions: true,
                onClick: ($event)=>{ this.preCreateTemplate($event); },
                enabled: true
            }
        ];

        angular.element('.tinymceLib').remove();
        var tiny5 = document.createElement('script');
        tiny5.setAttribute('class', 'tinymceLib');
        tiny5.setAttribute('src', this.ICM_ASSETS_URL +'client/js/lib/tinymce_v5/tinymce_v5.min.js');
        document.head.appendChild(tiny5);

        this.ActionBarService.registerActions(this.actions);

        // handle linking directly to the outreach page with the create template modal opened
        if(this.$location.hash() === 'createTemplate') {
            this.preCreateTemplate();
        }
        // handle linking directly into icm-web app with the fake compose modal open
        //   using this redirect approach so that when closing the modal it takes you back to the
        //   outreach list page. otherwise, since we came from outside of the app, it takes the
        //   user back to the icm landing page
        if(this.$location.hash() === 'composeEmail') {
            this.$location.url('/outreach/compose');
        }

        UserActivityService.trackOutreachListPage();
    }

    ContactManagerOutreachListController.prototype.translatedTemplateTabString = function translatedTemplateTabString() {
        this.templateCount = this.EmailTemplateService.getTemplates().length;
        if (this.templateCount) {
            return `${this.templateTabString} (${this.templateCount}/50)`;
        }
        return this.templateTabString;
    };

    ContactManagerOutreachListController.prototype.showTemplateLimitModel = function showTemplateLimitModel(action, ev, id, state) {
        this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            fullscreen: false,
            locals: {
                stopNotification: false,
                templateCount: this.templateCount
            },
            template: `<md-dialog id="template-warnings-mini-modal" class="mw-mini-modal" aria-label="" layout="column">
                        <template-warning class="mw-mini-modal-wrapper" stop-notification="$ctrl.stopNotification" template-count="$ctrl.templateCount" layout="column"></delete-medialist>
                    </md-dialog>`,
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        }).then((data) => {
            if (data && data.stopNotification === true) {
                this._getAppSettings().then((contactSettings) => {
                    let newSettings = Object.assign(contactSettings, {showTemplateWarning: false});
                    this.ICMUserService.setAppSettings('contacts', newSettings);
                });
            }

            if (action) {
                switch (action){
                    case 'create':
                        this.createTemplate(ev);
                        break;
                    case 'update':
                        this.updateTemplate(ev, id, state);
                        break;
                }
            }
        });
    };

    ContactManagerOutreachListController.prototype.showTemplateLimitWarning = function showTemplateLimitWarning(action, ev, id, state) {
        this._getAppSettings().then((contactSettings) => {
            let showTemplateWarning = true;
            if (contactSettings && contactSettings.showTemplateWarning === false) {
                showTemplateWarning = false;
            }
            if (showTemplateWarning) {
                this.showTemplateLimitModel(action, ev, id, state);
            }
            else {
                switch(action) {
                    case 'create':
                        this.createTemplate(ev);
                        break;
                    case 'update':
                        this.updateTemplate(ev, id, state);
                        break;
                }
            }
        });
    };

    ContactManagerOutreachListController.prototype._getAppSettings = function _getAppSettings() {
        return new Promise((resolve, reject)=>{
            this.CoreUserService.getCurrent(true)
                .then((currentUser)=>{
                    resolve(this.ICMUserService.getAppSettings('contacts', currentUser._id));
                })
                .catch(err => {
                    reject(err);
                });
        });
    };

    ContactManagerOutreachListController.prototype._enableComposeButton = function _enableComposeButton() {
        if (this.isPermissions && !this.approveSenderLoading) {
            angular.element('.action-bar-button').removeAttr('disabled');
        }
    };

    ContactManagerOutreachListController.prototype._getCompanyAggregations = function _getCompanyAggregations() {
        // Get our splits while they're hot.
        const emptyStatDisplay = '--';

        this.distributionCount = emptyStatDisplay;
        this.openRate = emptyStatDisplay;
        this.clickToOpenRate = emptyStatDisplay;
        this.unsubscribedRate = emptyStatDisplay;

        this.EmailAnalyticsService.getCompanyAggregations().then((results) => {
            if(results) {
                if(Number.isFinite(results.distributions)) {
                    this.distributionCount = results.distributions.toString();
                }

                if(Number.isFinite(results.openRate)) {
                    this.openRate = results.openRate + '%';
                }

                if(Number.isFinite(results.clickRate)) {
                    this.clickToOpenRate = results.clickRate + '%';
                }

                if(Number.isFinite(results.unsubscribeRate)) {
                    this.unsubscribedRate = results.unsubscribeRate + '%';
                }
            }
        });
    };

    ContactManagerOutreachListController.prototype.onPage = function onPage(page){
        return this.getEmails(page-1, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
    };

    ContactManagerOutreachListController.prototype.getEmails = function getEmails(page, sortOrder, sortField, filterByType, findText){
        var that = this,
            step = 0;
        sortField = this.sortFieldMap[sortField] || sortField;

        if(page && page > 0){
            this.$location.search('page', page); //for back button support, if it's 0, we don't set the query param
            step = page;
        } else {
            this.$location.search('page', null);
        }
        return this.OutreachListFactory.getAllEmails(undefined, undefined, sortField, sortOrder, page, this.outreachEmailQueryPageSize, filterByType, findText).then(function(res){
            if(res.hits && res.hits.length >0){
                that.outreachEmails = res.hits;
                if(res.total && res.total > 0){
                    that.totalEmails = res.total;
                }
            } else {
                that.emptyStateVisible = true;
                that.outreachEmails = [];
                that.totalEmails = 0;
            }
        });
    };

    ContactManagerOutreachListController.prototype.onFilterByStatus = function onFilterByStatus(filterByType) {
        if (filterByType === '') {
            filterByType = undefined;
        }
        if(filterByType){
            this.$location.search('filterByStatusType', filterByType); //for back button support, if it's 0, we don't set the query param
            this.filterByStatusType = filterByType;
        }
        else {
            this.filterByStatusType = null;
            this.$location.search('filterByStatusType', null);
        }

        if(!this.isInitializing){
            return this.getEmails(0, this.sortOrder, this.sortField, filterByType, this.findText);
        } else {
            return this.$q.when('done');
        }
    };

    ContactManagerOutreachListController.prototype.onFindTextChange = function onFindTextChange(findText){
        if (typeof findText !== 'string') {
            return;
        }

        if(findText.length >= 3){
            this.$location.search('findText', findText); //for back button support, if it's 0, we don't set the query param
            this.findText = findText;
            return this.getEmails(0, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
        }
        else if (findText.length === 0){
            this.$location.search('findText', null);
            this.findText = null;
            return this.getEmails(0, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
        }
    };

    ContactManagerOutreachListController.prototype.onDelete = function(event, itemIdArr) {
        var deleteEmailDialogTitle = this.translationService.getLocalizedString('Delete Email?'),
            template = 'icm-web/views/partials/delete_email_distribution_dialog',
            payload = {
                data: {}
            };

        this.DialogService.dialog(deleteEmailDialogTitle, template, payload, function() {
            if (itemIdArr.length) {
                this.OutreachService.deleteOutreachEmail(itemIdArr).then(function() {
                    this.selectedItems = [];
                    this.pageNumber = 0;
                    this.getEmails(this.pageNumber, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
                }.bind(this))
                .catch(function(){
                    this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
                }.bind(this));
            }
        }.bind(this));
    };

    ContactManagerOutreachListController.prototype.onDuplicate = function(event, item) {
        if (Object.prototype.toString.call(item) === '[object Object]' && item !== null) {
            this.compose(item, 'duplicate');
        }
    };

    ContactManagerOutreachListController.prototype.duplicateTemplate = function duplicateTemplate(ev, id) {
        if (this.templateCount === 50) {
            return this.showTemplateLimitModel();
        }
        else if (this.templateCount > 44) {
            return this.showTemplateLimitWarning('update', ev, id, 'duplicate');
        }
        else {
            return this.updateTemplate(ev, id, 'duplicate');
        }
    };

    ContactManagerOutreachListController.prototype.updateTemplate = function updateTemplate(ev, id, state) {
        this.EmailTemplateService.getTemplateById(id).then((response) => {
            let data = this.EmailTemplateService.populateTemplate(response.data);
            this.$mdDialog.show({
                template: `<mw-outreach-template on-callback="$ctrl.onCallback()" approved-senders="$ctrl.approvedSenderList" template-id="$ctrl.templateId" template-title="$ctrl.templateTitle" template-body="$ctrl.templateBody"></mw-outreach-template>`,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true,
                // This is a globally available controller for the purposes of attaching locals for data binding
                controller: 'MwMiniModalDialogController',
                controllerAs: '$ctrl',
                bindToController: true,
                locals: {
                    approvedSenderList: this.approvedSenderList,
                    templateId: (state === 'duplicate') ? '' : data.id,
                    templateTitle: (state === 'duplicate') ? '' : data.title,
                    templateBody: data.body,
                    onCallback: () => {
                        this.$scope.$broadcast('updateTemplates');
                    }
                }
            });
        })
        .catch((error) => {
            if(error.data === 'Template not found'){
                this.deletedTemplateWarning();
            } else {
                this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }
        });
    };

    ContactManagerOutreachListController.prototype.preCreateTemplate = function preCreateTemplate(ev) {
        if (this.templateCount === 50) {
            return this.showTemplateLimitModel();
        }
        else if (this.templateCount > 44) {
            return this.showTemplateLimitWarning('create', ev);
        }
        else {
            return this.createTemplate(ev);
        }
    };

    ContactManagerOutreachListController.prototype.createTemplate = function createTemplate(ev) {
        this.$mdDialog.show({
            template: `<mw-outreach-template on-callback="$ctrl.onCallback()" approved-senders="$ctrl.approvedSenderList"></mw-outreach-template>`,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl',
            bindToController: true,
            locals: {
                approvedSenderList: this.approvedSenderList,
                onCallback: () => {
                    this.$scope.$broadcast('updateTemplates');
                }
            }
        });
    };

    ContactManagerOutreachListController.prototype.deletedTemplateWarning = function() {
        this.$mdDialog.show(
            this.$mdDialog.mwConfirm()
                .title(this.$translate.instant('icm-outreach__template-deleted-warning--header'))
                .textContent(this.$translate.instant('icm-outreach__template-deleted-warning--body'))
                .ok(this.$translate.instant('OK'))
                .cancel(this.$translate.instant('Cancel'))
            ).then(
                () => {
                    this.$mdDialog.hide();
                    this.$scope.$broadcast('refreshTemplatesSelected');
                    this.preCreateTemplate();
                },
                () => {
                     this.$mdDialog.cancel();
                }
            );
    };

    ContactManagerOutreachListController.prototype.composeWithTemplate = function composeWithTemplate(templateId) {
     this.EmailTemplateService.getTemplateById(templateId).then(() =>{
            if(Array.isArray(this.approvedSenderList) && this.approvedSenderList.length) {
                this.$location.url('/outreach/compose?templateId=' + templateId);
                this.$scope.$apply();
            }
            else {
                this.showEmailUnApprovedDialog();
            }
        }).catch((error) =>{
            if(error.data === 'Template not found'){
                this.deletedTemplateWarning();
            } else {
                this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }
        });
    };

    ContactManagerOutreachListController.prototype.compose = function compose(distribution, state) {
        if(Array.isArray(this.approvedSenderList) && this.approvedSenderList.length) {
            this.composeEmail(this.approvedSenderList, distribution, state);
        }
        else {
            this.showEmailUnApprovedDialog();
        }
    };

    ContactManagerOutreachListController.prototype.getApprovedSenders = function getApprovedSenders() {
        var defer = this.$q.defer();

        this.ICMEmailService.getIcmApprovedSenders().then(function afterSuccess(sendersList) {
            var approvedSenderList = [];
            this.approveSenderLoading = false;
            this._enableComposeButton();
            if(sendersList.length){
                for(var i = 0; i < sendersList.length; i++){
                    /*jshint camelcase:false*/
                    if(sendersList[i].is_approved) {
                        approvedSenderList.push(sendersList[i]);
                    }
                }

                if(approvedSenderList.length) {
                    defer.resolve(approvedSenderList);
                } else {
                    defer.reject('request_pending');
                }
            } else {
                defer.reject('unapproved');
            }
        }.bind(this))
        .catch(function afterFail() {
            defer.reject();
        }.bind(this));

        return defer.promise;
    };

    ContactManagerOutreachListController.prototype.showEmailUnApprovedDialog = function showEmailUnApprovedDialog() {
        var dialogTitle = this.translationService.getLocalizedString('Compose Email');

        this.DialogService.dialog(dialogTitle,'icm-web/views/partials/email_unapproved_dialog', {}, function callback() {
            this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
        }.bind(this));
    };

    ContactManagerOutreachListController.prototype.composeEmail = function composeEmail (senderObjects, distribution, state) {
        var distributionParam = '';
        this.ICMEmailService.resetRecipients();
        this.ICMEmailService.setSender(senderObjects);
        distributionParam += (distribution && distribution._id) ?  '/' + distribution._id : '';
        distributionParam += (state) ?  '/' + state : '';

        this.$location.path('/outreach/compose' + distributionParam);
    };

    ContactManagerOutreachListController.prototype.onSortChange = function onSortChange(sortField, sortOrder){
        var sortFieldKey = sortField.replace('-', '');
        this.sortField = this.sortFieldMap[sortFieldKey];
        this.sortOrder = sortOrder ? 'DESC' : 'ASC';
        this.$location.search('sortField', sortFieldKey);
        this.$location.search('sortOrder', this.sortOrder);

        return this.getEmails(0, this.sortOrder, this.sortField, this.filterByStatusType, this.findText);
    };

    ContactManagerOutreachListController.prototype.changeActiveTab = function changeActiveTab(tab) {
        if (tab === this.templateTab) {
            this.$scope.$broadcast('updateTemplates');
        }
        this.activeTab = tab;
    };

}());